import type { Plan } from "@memorang/types";

type PlanTier = "oneWeek" | "oneMonth" | "threeMonths";

const ORDERS_BASE_URL = "https://mypte.pearsonpte.com/orders/products";
const DEV_ORDERS_BASE_URL =
	"https://test-taker-develop.ignite-dev.com/orders/products";

const EXTERNAL_PURCHASE_URLS: Record<number, Record<PlanTier, string>> = {
	// PTE Academic [PROD]
	401: {
		oneWeek: `${ORDERS_BASE_URL}/A103000453437`,
		oneMonth: `${ORDERS_BASE_URL}/A103000453439`,
		threeMonths: `${ORDERS_BASE_URL}/A103000453441`,
	},
	// PTE Core [PROD]
	402: {
		oneWeek: `${ORDERS_BASE_URL}/A103000459666`,
		oneMonth: `${ORDERS_BASE_URL}/A103000459668`,
		threeMonths: `${ORDERS_BASE_URL}/A103000459670`,
	},
};

const DEV_EXTERNAL_PURCHASE_URLS: Record<number, Record<PlanTier, string>> = {
	// PTE Academic [DEV]
	293: {
		oneWeek: `${DEV_ORDERS_BASE_URL}/A103000453437`,
		oneMonth: `${DEV_ORDERS_BASE_URL}/A103000453439`,
		threeMonths: `${DEV_ORDERS_BASE_URL}/A103000453441`,
	},
	// PTE Core [DEV]
	294: {
		oneWeek: `${DEV_ORDERS_BASE_URL}/A103000459666`,
		oneMonth: `${DEV_ORDERS_BASE_URL}/A103000459668`,
		threeMonths: `${DEV_ORDERS_BASE_URL}/A103000459670`,
	},
};

const getPlanTier = (plan: Plan): PlanTier | undefined => {
	if (
		(plan.interval === "week" && plan.duration === 1) ||
		(plan.interval === "day" && plan.duration === 7)
	) {
		return "oneWeek";
	}

	if (plan.interval === "month" && plan.duration === 1) {
		return "oneMonth";
	}

	if (plan.interval === "month" && plan.duration === 3) {
		return "threeMonths";
	}

	return undefined;
};

export const getExternalPurchaseUrl = ({
	productId,
	selectedPlan,
	isDev = false,
}: {
	productId: number;
	selectedPlan: Plan | undefined;
	isDev?: boolean;
}) => {
	if (!selectedPlan) {
		return undefined;
	}

	const planTier = getPlanTier(selectedPlan);
	if (!planTier) {
		return undefined;
	}

	const purchaseUrls = isDev
		? DEV_EXTERNAL_PURCHASE_URLS
		: EXTERNAL_PURCHASE_URLS;
	return purchaseUrls[productId]?.[planTier];
};
